// src/hooks/useStandaloneOrdersPage.ts
import { useState, useEffect, useCallback } from "react";
import {
  StandaloneOrderService,
  StandaloneOrderWithPOs,
} from "@/services/standalone-order.service";

export function useStandaloneOrdersPage(refreshToken: number = 0) {
  const [orders, setOrders] = useState<StandaloneOrderWithPOs[]>([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const result = await StandaloneOrderService.list(0, 100);
      setOrders(result.orders);
      setCount(result.count);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load, refreshToken]);

  return { orders, count, loading, reload: load };
}
